import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

const ListPageModalWrapper = ({ children, anchor, open, sx, variant, onClose, onCloseButtonClick, styleBox }) => {
  // The floating close button sits just outside the drawer's edge - which edge depends on
  // which side the drawer slides in from.
  const closeButtonSidePosition = anchor === "left" ? { left: "calc(50rem + 2rem)" } : { right: "calc(50rem + 2rem)" };

  return (
    <Drawer anchor={anchor} open={open} onClose={onClose} sx={sx} variant={variant} disableEnforceFocus>
      <IconButton sx={{ display: "flex", alignItems: "flex-start", width: "fit-content", position: "fixed", ...closeButtonSidePosition, top: "1rem", color: "var(--bg-color)" }} onClick={onCloseButtonClick}>
        <Icon>close</Icon>
      </IconButton>
      <Box width="50rem" height="100%" sx={styleBox}>
        {children}
      </Box>
    </Drawer>
  )
}

export default ListPageModalWrapper
